/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SquadList = {
    type: 'array',
    contains: {
        type: 'Squad',
    },
} as const;
